<template>
  <div>
    <Header />

    <v-container
      class="mt-10"
    >
      <v-card
        :loading="isLoading"
        :disabled="isLoading"
        max-width="600"
        class="mx-auto"
      >
        <!-- Error template -->
        <template v-if="error">
          <v-card-title>
            Error
          </v-card-title>

          <v-card-text
            class="subtitle-1"
          >
            <div>
              An error occurred. <br />
              Please try again later or email
              <a href="mailto:Support@GlobalCoachGroup.com">
                Support@GlobalCoachGroup.com
              </a>for assistance.
            </div>
          </v-card-text>
        </template>

        <!-- Completed template -->
        <template v-else-if="completed">
          <v-card-title>
            Congratulations
          </v-card-title>

          <v-card-text
            class="subtitle-1"
          >
            <div>
              Your account has been successfully unlocked.
            </div>

            <v-btn
              text
              class="mt-2 px-0"
              style="text-transform: none;"
              color="primary"
              @click="$router.push({ name: 'login' })"
            >
              Go back to login page
            </v-btn>
          </v-card-text>
        </template>

        <!-- Wait template -->
        <template v-else>
          <v-card-title>
            Account unlock
          </v-card-title>

          <v-card-text
            class="subtitle-1"
          >
            Loading...
          </v-card-text>
        </template>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import accountApi from '@/api/account/account';
import Header from '@/views/components/Header.vue';

export default {
  name: 'UnlockAccount',

  components: {
    Header,
  },

  data: () => ({
    isLoading: true,
    error: false,
    completed: false,
  }),

  created() {
    this.checkValidate();
  },

  methods: {
    async checkValidate() {
      try {
        this.isLoading = true;
        await accountApi.unlockAccount({
          uid64: this.$route.params.uid64,
          token: this.$route.params.token,
        });
        this.completed = true;
      } catch (err) {
        console.log(err);
        this.error = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
